import React from 'react'
import { styled } from 'styled-components'
import { basicShadow, colors, Page } from '../uiComponents.js'
import { Layout } from './Layout.js'

const A = styled.a`
  background-color: ${colors.keskoOrange};
  color: white;
  text-decoration: none;
  border-radius: 8px;
  padding: 12px 16px;
  cursor: pointer;
  box-shadow: ${basicShadow};

  &:hover {
    background-color: #e05e00;
  }
`

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 48px);
`

interface LoginProps {
  redirect: string
}

export const Login = ({ redirect }: LoginProps): React.JSX.Element => {
  const baseAuthUrl = '/oauth/authenticate'
  // Add redirect url if present
  const authUrl = redirect ? `${baseAuthUrl}?redirect=${encodeURIComponent(redirect)}` : baseAuthUrl

  return (
    <Layout isLogin>
      <Page>
        <Container>
          <A href={authUrl} title="Kirjaudu" id="login-btn">
            Kirjaudu sisään
          </A>
        </Container>
      </Page>
    </Layout>
  )
}
